module.exports = __webpack_public_path__ + "static/media/multiBar-selected.50571528.svg";